import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getMyEmployeeDetails = (email, token) => { 
  return axios.get(`${API_BASE_URL}/api/employees/me`, {
    params: { email },
    headers: {
      Authorization: `Bearer ${token}`, 
      'Content-Type': 'application/json'
    }
  });
}; 

// export const getMyEmployeeDetails = async (token) => {  
//   const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/employees/me`, {
//     method: 'GET',
//     headers: {
//       'Authorization': `Bearer ${token}`,
//       'Content-Type': 'application/json'
//     }
//   });
//   if (!response.ok) throw new Error('Failed to fetch');
//   return response.json();
// };

